/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PncDetailModel} from '../../models/pnc-detail/pnc-detail.model';
import {PartNumberChangesPdfCredentialsModel} from './models/part-number-changes-pdf-credentials.model';
import {PartNumberChangesPdfOldPncModel} from './models/part-number-changes-pdf-old-pnc.model';
import {PartNumberChangesPdfSolutionModel} from './models/part-number-changes-pdf-solution.model';

export class PartNumberChangesDetailExportPdfMapper {
    private constructor() {
    }

    static fromPncDetailToCredentialsInformation(input: PncDetailModel): PartNumberChangesPdfCredentialsModel {
        let model: PartNumberChangesPdfCredentialsModel = null;
        if (input != null) {
            model = {
                pncNumber: input.number,
                createdOn: input.creationDatetime,
                partner: input.partner,
                country: input.country,
                shipToParty: input.shipToParty,
                supplyingPackingPlant: input.supplyingPackingPlant,
            };
        }
        return model;
    }

    static fromPncDetailToOldPartNumberChangeInformation(input: PncDetailModel):
            PartNumberChangesPdfOldPncModel {
        let model: PartNumberChangesPdfOldPncModel = null;
        if (input != null) {
            model = {
                oldPartNumber: input.material,
                quantity: input.quantity,
                salesVariant: input.salesVariant,
                modelCode: input.modelCode,
                color: input.colourCode,
                fullLotNumber: input.fullLotNumber,
                additionalFullLotNumbers: input.additionalFullLotNumbers,
                problemDescription: input.problemDescription,
                spoNumber: input.spoNumber,
                additionalSpoNumbers: input.additionalSpoNumbers,
                pncType: input.type?.code
            };
        }
        return model;
    }

    static fromPncDetailToPncSolutionInformation(input: PncDetailModel):
            PartNumberChangesPdfSolutionModel {
        let model: PartNumberChangesPdfSolutionModel = null;

        if (input != null) {
            model = {
                newMaterial: input.newMaterial,
                additionalMaterials: input.additionalMaterials,
                additionalInformation: input.additionalInformation,
                solvedBy: input.solvedBy,
                solvedOn: input.solvedOn,
                iLevel: input.iLevel,
                eeAdditionalInformation: input.eeAdditionalInformation,
                validatedBy: input.validatedBy,
                requiresFlashing: input.requiresFlashing,
                solutionSupplyingPackingPlant: input.solutionSupplyingPackingPlant
            };
        }
        return model;
    }
}
